import React from 'react';
import { Check, X } from 'lucide-react';

interface ComparisonColumn {
  header: string;
  values: (boolean | string)[];
}

interface ComparisonTableProps {
  rowHeaders: string[];
  columns: ComparisonColumn[];
}

export const ComparisonTable: React.FC<ComparisonTableProps> = ({ rowHeaders, columns }) => {
  return (
    <div className='not-prose my-6 overflow-x-auto'>
      <table className='w-full border-collapse'>
        <thead>
          <tr className='border-b-2 border-border'>
            <th className='text-left p-3 font-semibold text-sm' />
            {columns.map((column, index) => (
              <th key={index} className='text-center p-3 font-semibold text-sm bg-muted'>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rowHeaders.map((rowHeader, rowIndex) => (
            <tr
              key={rowIndex}
              className='border-b border-border hover:bg-muted/30 transition-colors'
            >
              <td className='p-3 font-medium text-sm'>{rowHeader}</td>
              {columns.map((column, colIndex) => {
                const value = column.values[rowIndex];
                return (
                  <td key={colIndex} className='p-3 text-center'>
                    {typeof value === 'boolean' ? (
                      value ? (
                        <Check className='h-5 w-5 text-green-600 dark:text-green-400 mx-auto' />
                      ) : (
                        <X className='h-5 w-5 text-red-600 dark:text-red-400 mx-auto' />
                      )
                    ) : (
                      <span className='text-sm text-muted-foreground'>{value}</span>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
